







































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';
import WaveSurfer from "wavesurfer.js";
import {uuid} from 'vue-uuid'

const dialog = namespace('dialog')
const forms = namespace('forms')
const profile = namespace('profile')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
  },
  name: "AddComentForm"
})
export default class AddComentForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options:any
  @profile.Mutation('changeContacts') protected changeContacts: any

  isValidBtn:boolean = false
  title:string = ''
  value:string = ''

  @Watch('fullDialogShow')
  resetAddLinkForm() {
    this.title = ''
    this.value = ''
  }

  save() {
    let links = [...this.options.badge.promo, {
      title: this.title,
      value: this.value,
      type: 'link'
    }]
    let payload = {
      id: this.options.badge.id,
      contacts: this.options.badge.contacts,
      promo: links,
      locations: this.options.badge.locations,
      isCurrentCompany: this.options.isCurrentCompany
    }
    this.changeContacts(payload)

    this.SetFullDialogShow(false)
  }


  changeLink() {
    this.isValidBtn = this.title.length != 0 && this.value.length != 0
  }

}
